import { menuLinkNames } from '../app/constants/application-constants';

export const cdnBaseUrl = 'https://uat-cdn.hill-laboratories.com/';

export const environment = {
    production: false,
    cartId: 'cartId',
    restBaseURL: 'https://70x4v7xmpg.execute-api.ap-southeast-2.amazonaws.com/uat',
    apiServicesDomain: '70x4v7xmpg.execute-api.ap-southeast-2.amazonaws.com/uat',
    nzPostPublicApiKey: '7cc1879c-ad81-4efd-88ac-b42775912667',
    cdnCatalogueImageUrl: `${cdnBaseUrl}images/catalogueitem/`,
    cdn60x60Images: '60x60/',
    cdn300x300Images: '300x300/',
    useUniversalLogin: false,
    environment: 'uat',
    hiddenLinks: [
        menuLinkNames.HONEY_BLENDING,
        menuLinkNames.HONEY_FORECASTING,
        menuLinkNames.MY_AGENTS
    ],
    honeyBlendingGroupName: 'Honey Blending',
    honeyForecastingGroupName: 'Honey Forecasting',
    honeyBlendingUrl: 'https://uat-blending.hill-laboratories.com/',
    honeyForecastingUrl: 'https://uat-forecasting.hill-laboratories.com/',
    windcaveUrl: 'https://uat.windcave.com/pxmi3/',
    showPersonaOptions: true,
    checkAccountVerification: true,
    showLogoutAfterCheckout: false,
    enableAlternateLayout: false,
    appLandingPage: 'catalogue/category',
    googleTagManager: {
        trackingId: 'GTM-KLT8X6J'
    },
    recaptchaKey: '6Lc5wB8pAAAAACbKGX69oAYS1And8P8eVcrTWOid',
    javaOverrideURL: '',
    sentryDsn: 'https://048290c9e712846b4aaea064fb3bf8fa@o4509902856978432.ingest.us.sentry.io/4510541344866304',
    sentryRelease: '16c654fca8c866ed8538204fb4ab6afebfe0df68',
    /* ---------------------- favourite -----------------------------*/
    favouritesHost: 'https://70x4v7xmpg.execute-api.ap-southeast-2.amazonaws.com/uat',
    favouriteBaseURL: '/catalogue-item',
    accountLoginHost: 'https://70x4v7xmpg.execute-api.ap-southeast-2.amazonaws.com/uat',
    apiKey: 'cOhh5aewCM9uMUN4lOah65Ep7KgzBsfa4lDb0CZO',

    /* ---------------------- c-sharp -----------------------------*/
    csBaseURL: 'https://70x4v7xmpg.execute-api.ap-southeast-2.amazonaws.com/uat/cs',
    orderHistoryBaseUrl: 'https://70x4v7xmpg.execute-api.ap-southeast-2.amazonaws.com/uat',

    /* ---------------------- register -----------------------------*/
    registerHost: 'https://70x4v7xmpg.execute-api.ap-southeast-2.amazonaws.com/uat/cs',

    /* ---------------------- MyLab Service -----------------------------*/
    myLabBaseUrl: 'https://uat-api.hill-laboratories.com/mylab'
};
